import { render } from "./HomeCenter.vue?vue&type=template&id=07c67686"
import script from "./HomeCenter.vue?vue&type=script&lang=js"
export * from "./HomeCenter.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__